import { useEffect, useState } from "react";
import { OrderContent } from "../../order/OrderList";
import { templateTransactionData } from "../../../data/order/transactionTableData";
import CommonPaginationSection from "../../common/CommonPaginationSection";
import getBookings from "../../../controllers/booking/getBookings";
import { templateFlightOrderData } from "../../../data/order/ordersDataV2";
import getUserFlightBookings from "../../../controllers/booking/getUserFlightBookings";

function CustomerDetailOrdersFlightList({ data: accountData }) {
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    page: 1,
    perPage: 10,
    total: 10,
  });

  const [orders, setOrders] = useState([]);
  const [ogData, setOgData] = useState([]);

  const loadData = async () => {
    setLoading(true);
    const res = await getUserFlightBookings({
      limit: pagination.perPage,
      offset: ((pagination.page || 0) - 1) * pagination.perPage,
      id: accountData?._id,
    }).finally(() => setLoading(false));
    const meta = res?.data?.meta;
    const data = res?.data?.data;
    if (meta?.total) {
      setPagination({ ...pagination, total: meta?.total });
    }
    if (data) {
      setOgData(data);
      setOrders(data?.map((item) => templateFlightOrderData(item)));
    }
  };

  useEffect(() => {
    loadData();
  }, [pagination.page, pagination.perPage]);

  if (loading)
    return (
      <div className="w-full flex items-center justify-center py-6">
        <div className="primaryLoader"></div>
      </div>
    );

  return (
    <div className="w-full flex flex-col">
      <div className="w-full flex flex-col mt-4 bg-[#F0F6FC] gap-2 p-1 rounded-md">
        {orders.map((order, index) => (
          <Order key={index} order={order} og={ogData?.at(index)} />
        ))}
      </div>
      <CommonPaginationSection
        perPage={pagination.perPage}
        total={pagination.total}
        page={pagination.page}
        callback={(pg, perPage) =>
          setPagination({ ...pagination, page: pg, perPage })
        }
      />
    </div>
  );
}

export default CustomerDetailOrdersFlightList;

const Order = ({ order, og }) => {
  const bookingData = og?.flightBooking?.at(0);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  return (
    <div className="w-full flex  justify-between bg-white p-4 gap-3 rounded-md">
      <div className="flex flex-col md:flex-row justify-between flex-1">
        {order?.map(({ elements, width }, index) => (
          <div
            className={`w-full rounded-lg ${width || "flex-1"} ${
              !open && index !== 0 ? "hidden md:flex" : "flex"
            } flex-col ${
              open && "border-b pb-3"
            } mb-2 px-2 md:border-b-0 md:pb-0`}
            key={index}
          >
            {elements?.map((element, idx) => (
              <OrderContent element={element} key={idx} />
            ))}
          </div>
        ))}
      </div>
      <div
        className={`${
          //   bookingData?.status || og?.status ? "flex" : "hidden"
          ""
        } flex-col justify-between items-center `}
      >
        {/* <button
          className="cursor-pointer p-2 relative "
          disabled={loading}
          onClick={() => setOpen(true)}
        >
          {loading ? (
            <div className="primaryLoader"></div>
          ) : (
            <img
              src="/IconMore.svg"
              alt=""
              className="h-5 object-contain relative"
            />
          )}
        </button> */}
      </div>
    </div>
  );
};
